export enum ETipoDia {
  Natural = 0,
  Laboral = 1
}
